import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import './QbButton.css'
import { mergeToNewObject } from '../../../util/helpers';

const QbButton = ({ name, onClick, simple, style, icon, iconStyle, className }) => (
  <button
    style={style}
    onClick={() => onClick()}
    className={`${simple ? 'qb-button--simple' : 'qb-button'} ${className ? className : ''}`}
  >
    {
      icon ?
        <FontAwesomeIcon
          style={mergeToNewObject(name ? {marginRight: '5px'} : {}, iconStyle)}
          icon={icon}
        />
      : null
    }
    {name}
  </button>
)

export default QbButton



// WEBPACK FOOTER //
// ./src/components/shared/QbButton/QbButton.js